import csv from 'csv-stringify';
import moment from 'moment';

export default function csvExport(name, rowsForExport) {
	return csv(rowsForExport, (err, res) => {
		const exportFilename = `Export--${name}--${moment().format(
			'YYYY-MM-DD--HH-mm-ss'
		)}.csv`;
		const csvData = new Blob([res], { type: 'text/csv;charset=utf-8;' });
		//IE11 & Edge
		if (navigator.msSaveBlob) {
			navigator.msSaveBlob(csvData, exportFilename);
		} else {
			//In FF link must be added to DOM to be clicked
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(csvData);
			link.setAttribute('download', exportFilename);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	});
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/csvExport.js